<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseSpinner v-if="showSpinner" />
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9]+$/ }"
          validattor="^[A-Za-z0-9]+$"
          data-vv-as="Reference No."
          type="text"
          maxlength="50"
          name="referenceNumber"
          label-content="Reference Number"
          :placeholder="placeholders.referenceno"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('referenceNumber') }} </div>
      </b-col>
      <b-col md="6"> </b-col>
      <!-- <b-col md="12" class="border-bottom pb-3" /> -->
    </b-row>

    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="taxID"
          v-model="taxID"
          v-validate="{
            required: false,
          }"
          validattor="^[0-9]+$"
          data-vv-as="Tax ID"
          type="text"
          name="taxID"
          maxlength="9"
          label-content="Tax ID"
          :placeholder="placeholders.taxID"
          :class="{
            input: true,
            'is-danger': errors.has('taxID'),
          }"
          aria-describedby="taxID-live-feedback"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('taxID') }}
        </div>
      </b-col>
      <b-col md="3" class="d-none">
        <BaseELabel label="Geo" />
        <BaseDropdown
          v-model="geo"
          :field-id="geo"
          :options="geos"
          name="geo"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="businessName"
          v-model="businessName"
          v-validate="{ required: true }"
          data-vv-as="Business Name"
          type="text"
          name="businessName"
          maxlength="100"
          mark-required
          label-content="Business Name"
          :class="{
            input: true,
            'is-danger': errors.has('businessName'),
          }"
          :placeholder="placeholders.businessName"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('businessName') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="phoneNumber"
          v-model="phoneNumber"
          v-validate="{
            required: false,
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="phoneNumber"
          label-content="Phone Number"
          data-vv-as="Phone #"
          :class="{
            input: true,
            'is-danger': errors.has('phoneNumber'),
          }"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('phoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Residental Address"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <BaseEInputText
          id="streetAddress"
          v-model="streetAddress"
          type="text"
          name="streetAddress"
          maxlength="100"
          data-vv-as="Street"
          label-content="Street"
          :class="{
            input: true,
            'is-danger': errors.has('street'),
          }"
          :placeholder="placeholders.streetAddress"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('streetAddress') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="cityName"
          v-model="cityName"
          v-validate="{ required: true, regex: /^[A-Za-z -.]+$/ }"
          validattor="^[A-Za-z -.]+$"
          type="text"
          name="cityName"
          maxlength="20"
          label-content="City"
          mark-required
          data-vv-as="City Name"
          :class="{
            input: true,
            'is-danger': errors.has('cityName'),
          }"
          :placeholder="placeholders.cityName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('cityName') }}
        </div>
      </b-col>
      <b-col md="2">
        <BaseELabel mark-required label="State" />
        <BaseDropdown
          v-model="state"
          v-validate="'required'"
          :field-id="state"
          :options="states"
          name="state"
          :placeholder="placeholders.state"
          :class="$style.dropOptionstyle"
        ></BaseDropdown>
        <div v-show="errors.has('state')" class="error">
          State is required
        </div>
      </b-col>
      <b-col md="2">
        <BaseEInputText
          id="zip"
          v-model="zip"
          v-validate="{ required: false, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ }"
          validattor="[0-9]"
          maskker="(\d{5})(\d{4})"
          formatter="$1-$2"
          type="text"
          maxlength="10"
          name="zip"
          label-content="Zip"
          data-vv-as="Zip"
          :class="{
            input: true,
            'is-danger': errors.has('zip'),
          }"
          :placeholder="placeholders.zip"
        ></BaseEInputText>
        <div class="error"> {{ errors.first('zip') }} </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 border-bottom">
      <b-col class="col-9">
        <BaseTextarea
          id="comments"
          v-model="comments"
          v-validate="{ required: false }"
          maxlength="30"
          name="comments"
          label-content="Comments"
        ></BaseTextarea>
        <div class="error"> {{ errors.first('comments') }} </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="2">
        <BaseEButton @click="onSearch">
          Search
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.dropOptionstyle option {
  font-size: 16px;
}
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
<script>
import {
  experianPremierProfileReportMethods,
  orderReportMethods,
  toasterMethods,
  userMethods,
} from '@state/helpers'
import constant from '@constants/constant'
export default {
  props: {
    customerId: {
      type: Number || String,
      default: '',
    },
    customerUserId: {
      type: Number || String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    searchData: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expPremierProfileReportjsonData: '',
      errorLog: '',
      showSpinner: false,
      referenceNumber: null,
      taxID: null,
      businessName: '',
      streetAddress: null,
      state: '',
      stateCode: '',
      zip: null,
      phoneNumber: '',
      cityName: '',
      geos: [
        { text: 'True', value: true },
        { text: 'False', value: false },
      ],
      geo: 'false',
      comments: null,
      requestData: '',
    }
  },
  computed: {
    placeholders() {
      return {
        referenceno: 'Reference Number',
        businessName: 'Business Name',
        cityName: 'City Name',
        state: 'Select State',
        zip: 'xxxxx-xxxx',
        streetAddress: 'Street Address',
        phoneNumber: '(xxx) xxx-xxxx',
        taxID: 'xxxxxxxxx',
      }
    },

    states() {
      return this.$_allStates
    },
  },
  mounted() {
    if (this.searchData.length > 0) {
      this.loadRefineSearch()
    }
  },

  methods: {
    ...experianPremierProfileReportMethods,
    ...orderReportMethods,
    ...userMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    buildExpPremierProfileReport() {
      return JSON.stringify({
        UserId: this.currentUserId,
        ReferenceNumber: this.referenceNumber,
        OrderForCustomer: this.customerId,
        OrderForUser: this.customerUserId,
        ProductId: this.productId,
        Geo: this.geo,
        Comments: this.comments,
        Business: {
          TaxId: this.taxID,
          Name: this.businessName,
        },
        Address: {
          AddressType: constant.currentAddress,
          Street: this.streetAddress,
          City: this.cityName,
          StateId: this.state,
          StateCode: this.stateCode,
          Zip: this.zip,
        },
        Contact: {
          PhoneNumber: this.phoneNumber,
          TypeId: 0,
        },
        ResponseStatus: 4,
      }).replace(/^"(.*)"$/, '$1')
    },
    onSearch(selectedValue) {
      this.getStateCode()
      let userInfo = this.$store.state.auth.currentUser.userInfo
      var isOrderReportComponentValid = false
      var isExpPremierProfileReportComponentValid = false
      this.currentUserId = userInfo.userId
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (userInfo.roles.indexOf(constant.CreditAnalystOrLoanOfficer) !== -1) {
            isOrderReportComponentValid = response
            that.customerUserId = that.currentUserId
          }
          isExpPremierProfileReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isExpPremierProfileReportComponentValid
          ) {
            that.showSpinner = true
            that.requestData = that.buildExpPremierProfileReport()
            that
              .fetchPPRSearchReport({
                expPremierProfileReportjsonData: that.requestData,
              })
              .then((response) => {
                if (
                  response.data !== null &&
                  response.data.responseStatus === 1 &&
                  response.data.pprSearchResults !== undefined
                ) {
                  that.$router.push({
                    name: 'pprSearchResults',
                    params: {
                      searchResponse: response.data,
                      searchRequest: that.requestData,
                      searchFor: that.businessName, // that.companyName,
                    },
                  })
                } else if (
                  response.data.message !== '' &&
                  response.data.message !== null &&
                  response.data.message !== undefined
                ) {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: response.data.message,
                    variant: constant.errorMessagetype,
                  })
                } else {
                  this.setAlert({
                    title: constant.imageHeaderError,
                    msg: constant.errorMessage,
                    variant: constant.errorMessagetype,
                  })
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
                this.errorLog = error
              })
          }
        })
      })
    },
    loadRefineSearch() {
      if (
        this.searchData !== undefined &&
        this.searchData !== null &&
        this.searchData.length > 0
      ) {
        this.showSpinner = true
        this.searchData = JSON.parse(this.searchData)

        this.referenceNumber =
          this.searchData.ReferenceNumber !== ''
            ? this.searchData.ReferenceNumber
            : null
        this.businessName = this.searchData.Business.Name
        this.taxID =
          this.searchData.Business.TaxId !== ''
            ? this.searchData.Business.TaxId
            : null
        this.phoneNumber =
          this.searchData.Contact.PhoneNumber !== ''
            ? this.searchData.Contact.PhoneNumber
            : ''
        this.streetAddress =
          this.searchData.Address.Street !== ''
            ? this.searchData.Address.Street
            : null
        this.cityName =
          this.searchData.Address.City !== ''
            ? this.searchData.Address.City
            : null
        this.state =
          this.searchData.Address.StateId !== ''
            ? this.searchData.Address.StateId
            : ''
        this.zip =
          this.searchData.Address.Zip !== ''
            ? this.searchData.Address.Zip
            : null
        this.comments =
          this.searchData.Comments !== '' ? this.searchData.Comments : null
        this.geo = this.searchData.Geo !== '' ? this.searchData.Geo : ''
      }
      this.showSpinner = false
    },
    getStateCode() {
      if (this.state !== '') {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxbirtdate =
        today.getFullYear() + '-' + month + '-' + today.getDate()
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
}
</script>
